(() => {
  const pad = (value) => String(value).padStart(2, '0');

  const getEndTime = (banner) => {
    if (banner.dataset.countdownMode === 'date') {
      const fixedEnd = Date.parse(banner.dataset.endDate || '');
      if (Number.isFinite(fixedEnd)) return fixedEnd;
    }

    const endOfDay = new Date();
    endOfDay.setHours(23, 59, 59, 999);
    return endOfDay.getTime();
  };

  const initCountdown = (banner) => {
    if (banner.dataset.countdownReady === 'true') return;
    banner.dataset.countdownReady = 'true';

    const hours = banner.querySelector('[data-deal-hours]');
    const minutes = banner.querySelector('[data-deal-minutes]');
    const seconds = banner.querySelector('[data-deal-seconds]');
    let endTime = getEndTime(banner);

    const update = () => {
      let remaining = endTime - Date.now();

      if (remaining <= 0 && banner.dataset.countdownMode !== 'date') {
        endTime = getEndTime(banner);
        remaining = Math.max(0, endTime - Date.now());
      }

      const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
      hours.textContent = pad(Math.floor(totalSeconds / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    };

    update();
    banner._dealTimer = window.setInterval(update, 1000);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-first-order-deal]').forEach(initCountdown);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const banner = event.target.querySelector('[data-first-order-deal]');
    if (banner?._dealTimer) window.clearInterval(banner._dealTimer);
  });
})();
